import React from "react";

// Inline icons that inherit colour from `currentColor`, so active / inverted
// states are driven by CSS colour alone (no filters or per-state image files).
const Svg = ({ children, className = "", size = 24 }) => (
  <svg
    className={`bv-mega-header__icon ${className}`}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const SearchIcon = props => (
  <Svg {...props}>
    <circle cx="10.5" cy="10.5" r="6.5" />
    <path d="M15.5 15.5L21 21" />
  </Svg>
);

export const MenuIcon = props => (
  <Svg {...props}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Svg>
);

export const CloseIcon = props => (
  <Svg {...props}>
    <path d="M5 5l14 14M19 5L5 19" />
  </Svg>
);

export const ChevronDownIcon = props => (
  <Svg {...props}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);

export const ChevronRightIcon = props => (
  <Svg {...props}>
    <path d="M9 6l6 6-6 6" />
  </Svg>
);

export const ArrowUpRightIcon = props => (
  <Svg {...props}>
    <path d="M7 17L17 7M8 7h9v9" />
  </Svg>
);
